import React from 'react'
import './error.css'

export const ErrorPage = ({ 
  errorCode = '404', 
  title = 'Página no encontrada', 
  message = 'Lo sentimos, la página que estás buscando no existe.',
}) => {

  return (
    <div className='page error-page'>
      <div className='error-container'>
        <div className='error-code'>{errorCode}</div>
        <div className='error-title'>{title}</div>
        <div className='error-message'>{message}</div>
      </div>
    </div>
  )
}
